
const Accounts = () => {
    return(
        <div>AAAAAAAAAAAccounts</div>
    )
}

export default Accounts;